import { render, staticRenderFns } from "./IdentityClient.vue?vue&type=template&id=6351c69f&scoped=true&"
import script from "./IdentityClient.vue?vue&type=script&lang=js&"
export * from "./IdentityClient.vue?vue&type=script&lang=js&"
import style0 from "./IdentityClient.vue?vue&type=style&index=0&id=6351c69f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351c69f",
  null
  
)

export default component.exports